import { createBrowserHistory, createHashHistory } from "history";

// called on first page load
// window.analytics.page(window.location.toString().split("?")[0]);
var history = createBrowserHistory();

history.listen(function (location) {
  // called on further page loads
  // location.pathname
  //window.analytics.page(window.location.toString().split("?")[0]);
  window.scrollTo(0, 0);
});

export default history;
